import React from 'react'
import './customStaticPages.css'
import ShareIcon from '../../../assets/share-svg-black.svg'
import EditIcon from '../../../assets/edit-svg-black.svg'
import DeleteIcon from '../../../assets/delete-svg-black.svg'

const CardListComponent = ({
  id = '',
  cardStyle = {},
  pageTitle = '',
  pageUrl = '',
  lastModified = '',
  onClick = () => {},
  onEdit = () => {},
  onShare = () => {},
  onDelete = () => {},
  hideOptions = false,
  activeFlag = false,
}) => {
  return (
    <div
      style={{
        width: '100%',
        aspectRatio: '1181/78',
        boxShadow: ' 3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        borderRadius: '4px',
        display: 'flex',
        justifyContent: 'center',
        background: '#ececec',
        gap: '0 2.2%',
        padding: '.4vw .6vw',
        ...cardStyle,
      }}
      tabIndex={10}
      className={`page-hover ${activeFlag ? 'page-selected' : ''}`}
      onClick={onClick}
    >
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          background: 'none',
          width: '100%',
        }}
      >
        <div
          style={{ fontSize: '12px' }}
          className="d-flex justify-content-between align-items-center w-100"
        >
          <p
            style={{
              marginBlockEnd: '0',
              fontWeight: '600',
              fontSize: 'max(1vw,14px)',
              width: '40%',
              background: 'none',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {pageTitle}
          </p>
          <p
            style={{
              marginBlockEnd: '0',
              fontWeight: '400',
              fontSize: 'max(1vw,14px)',
              width: '40%',
              background: 'none',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              color: '#0073f6',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            {pageUrl}
          </p>
          <p
            style={{
              marginBlockEnd: '0',
              fontWeight: '400',
              fontSize: 'max(0.85vw, 10px)',
              width: '12%',
              background: 'none',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {lastModified}
          </p>
          <div
            style={{
              width: '5%',
              fontSize: '20px',
              fontWeight: '700',
              cursor: 'pointer',
            }}
            className="d-flex justify-content-center align-items-center position-relative options-menu-dots"
            tabIndex={100}
          >
            {!hideOptions && (
              <button style={{ border: 'none', outline: 'none', background: 'none' }}>⋮</button>
            )}
            <div
              className="position-absolute option-menu-button"
              style={{ left: '-110px' }}
              tabIndex={0}
            >
              <p
                style={{ marginBlockEnd: '0', height: '26px', width: '126px' }}
                className="hover-semibold d-flex justify-content-evenly align-items-center"
                onClick={onShare}
              >
                <img src={ShareIcon} alt="" />
                <span className="d-inline-block" style={{ width: '60%' }}>
                  Share
                </span>
              </p>
              <p
                style={{ marginBlockEnd: '0', height: '26px', width: '126px' }}
                className="hover-semibold d-flex justify-content-evenly align-items-center"
                onClick={() => onEdit(id)}
              >
                <img src={EditIcon} alt="" />
                <span className="d-inline-block" style={{ width: '60%' }}>
                  Edit
                </span>
              </p>
              <p
                style={{ marginBlockEnd: '0', height: '26px', width: '126px' }}
                className="hover-semibold d-flex justify-content-evenly align-items-center"
                onClick={onDelete}
              >
                <img src={DeleteIcon} alt="" />
                <span className="d-inline-block" style={{ width: '60%' }}>
                  Delete
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardListComponent
